<template>
  <div class="wrapper w-full h-full" id="wrapper" v-loading="loading">
    <Header :auth-user="authUser"/>
    <div class="ocr-display-sp">
      <Breadcrumb :user="authUser"/>
    </div>
    <div class="flex h-sidebar">
      <div class=" content w-full">
        <div class="ocr-home" :class="[getNameClass()]">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/pages/layouts/breadcrumb";
import Header from "@/pages/layouts/Header";
import { mapState, mapActions } from "vuex";
import {ROLE_ADMIN} from "@/constants/organization";
import { PATH_TEMPLATE, PATH_EXPORT_XLSX, PATH_BUSINESS_CARD, WIDTH_DEVICE } from "@/const/batch";
import common from "@/mixins/common.mixin";

export default {
  name: "Main",
  mixins: [common],
  data() {
    return {
      sidebar_status: true,
      authUser: {}
    };
  },
  components: {
    Header,
    Breadcrumb
  },
  methods: {
    ...mapActions("charset", ["getCharset"]),
    ...mapActions("detect", ["getDetect"]),
    ...mapActions("engine", ["getEngine"]),
    ...mapActions("auth", ["getAuthUser"]),
    ...mapActions("device", ['setDevice']),
    showRouteName() {
      if (!this.authUser) {
        return this.$router.push('/login')
      }
      const arr = this.getNameByRole();
      const index = arr.findIndex((name) => name === this.$route.name)
      if (index === -1) {
        return this.$router.push('/404')
      }
    },
    getNameByRole() {
      let arr = []
      if (this.authUser.role === ROLE_ADMIN && this.authUser.is_superuser) {
        arr.push(...['admin_organizations', 'admin_user_organizations', 'admin_statistical_organizations', "home"])
      } else {
        arr.push(...['home', 'user_profile', 'user_list_key'])
        if (this.authUser.role === ROLE_ADMIN) {
          arr.push(...['admin_user', 'admin_statistical'])
        }
      }
      const indexTemplate = this.authUser.menu_list.findIndex((obj) => obj.path === PATH_TEMPLATE)
      const indexExportXlsx = this.authUser.menu_list.findIndex((obj) => obj.path === PATH_EXPORT_XLSX)
      const indexBusinessCard = this.authUser.menu_list.findIndex((obj) => obj.path === PATH_BUSINESS_CARD)
      if (indexTemplate !== -1) {
        arr.push(...['templates', 'template.edit', 'template.assignment', 'master_template', 'confirm_result', 'test-ocr'])
      }
      if (indexExportXlsx !== -1) {
        arr.push(...['export_xlsx', 'export_xlsx_result'])
      }
      if (indexBusinessCard !== -1) {
        arr.push(...['business_card', 'business_card_result'])
      }

      return arr
    },
    getNameClass() {
      return this.checkScreen(['home', 'export_xlsx', 'business_card', 'export_xlsx_result', 'business_card_result', 'confirm_result']) ? 'cover-home'
          : (this.checkScreen(['template.edit', 'export_xlsx_result', 'business_card_result', 'confirm_result']) ? 'p-6 main cover-home-sp' : 'p-6 main')
    },
    checkScreen(arrayRouteName) {
      return arrayRouteName.indexOf(this.$route.name) > -1
    },
    $_isMobile() {
      const { body } = document
      const rect =  body.getBoundingClientRect()
      const isMobile = rect.width - 1 < WIDTH_DEVICE
      this.$store.dispatch('device/setDevice', isMobile ? 'mobile' : 'desktop')
      this.$store.dispatch('device/setDevicePixel', rect.width)

    }
  },
  beforeMount() {
    window.addEventListener('resize', this.$_isMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_isMobile)
  },
  computed: mapState(["loading"]),
  async created() {
    this.$_isMobile()
    this.getCharset({});
    this.getDetect({});
    this.getEngine({});
    this.authUser = await this.getAuthUser();
    this.showRouteName()
  },
  mounted () {
    document.body.setAttribute('ocr-browser', this.getBrowserName());
  }
};
</script>

<style>
html,
body,
#app {
  height: 100%;
}
html,
body,
#wrapper {
  /* min-width: 1200px; */
}
.h-sidebar {
  padding-top: 62px;
}
@media screen and (max-width: 768px){
  html, body, #wrapper#wrapper {
    min-width: 100%;
    width: 100%;
  }
}
@media screen and (max-width: 820px){
  .h-sidebar {
    height: auto !important;
    padding-top: 0 !important;
  }
  .ocr-display-sp {
    padding-top: 50px !important;
  }
}
.el-loading-spinner {
  left: 50%;
}
.main {
  height: calc(100vh - 62px);
}
.w-sidebar-small {
  width: 48px;
}
.w-sidebar-big {
  width: calc(100% - 48px);
}
.btn-main {
  background: #fdb92c !important;
  border-color: #fdb92c !important;
  color: black !important;
}
.btn-main:hover {
  background: #f8b021 !important;
  border-color: #fdb92c !important;
}
.cover-home {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
}
@media only screen and (max-width: 821px) {
  .ocr-home {
    padding: 12px;
  }
  .cover-home-sp {
    padding: 0;
  }
}
</style>
